import { LocationsResponse } from '@/services/locations';
import { SALFA_HIDDEN_LOCATION_IDS } from './constants';

export const filterHiddenLocations = (locations: LocationsResponse[], isSalfa: boolean): LocationsResponse[] => {
  if (!isSalfa) {
    return locations;
  }

  return locations.filter((l) => !SALFA_HIDDEN_LOCATION_IDS.includes(l.id));
};
